import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TSupersetDashboard, TSupersetStore } from './types';
import { SUPERSET_SLICE_NAME } from './constants';

const initialState: TSupersetStore = {
	dashboards: null,
	dashboardsLoading: false,
	selectedDashboardId: null,
};

const supersetSlice = createSlice({
	name: SUPERSET_SLICE_NAME,
	initialState,
	reducers: {
		getSupersetDashboardsRequest: (state) => {
			state.dashboardsLoading = true;
		},
		getSupersetDashboardsSuccess: (state, action: PayloadAction<TSupersetDashboard[]>) => {
			state.dashboards = action.payload;
			state.dashboardsLoading = false;

			// Keep the current selection when it is still available, otherwise fall back to the first
			// dashboard the user has access to.
			const isSelectionAvailable = action.payload.some(
				(dashboard) => dashboard.id && dashboard.id === state.selectedDashboardId,
			);
			if (!isSelectionAvailable) {
				state.selectedDashboardId = action.payload.find((dashboard) => dashboard.id)?.id ?? null;
			}
		},
		getSupersetDashboardsFailure: (state) => {
			state.dashboardsLoading = false;
		},
		setSelectedSupersetDashboardId: (state, action: PayloadAction<string | null>) => {
			state.selectedDashboardId = action.payload;
		},
		clearSupersetDashboards: (state) => {
			state.dashboards = null;
			state.selectedDashboardId = null;
		},
	},
});

export const {
	getSupersetDashboardsRequest,
	getSupersetDashboardsSuccess,
	getSupersetDashboardsFailure,
	setSelectedSupersetDashboardId,
	clearSupersetDashboards,
} = supersetSlice.actions;

export default supersetSlice.reducer;
